module.exports = __webpack_public_path__ + "fonts/262fb10.eot";